import { forwardRef } from 'react';
import { StyledAccordionTrigger } from './styled';
import Icon from '../../../components/Icon';
import { useAccordionItemContext } from '../../../contexts/accordion';

const AccordionTrigger = forwardRef(({ children, ...props }, ref) => {
  const { isOpen, triggerProps } = useAccordionItemContext();

  return (
    <h3>
      <StyledAccordionTrigger ref={ref} {...triggerProps(props)}>
        {children}
        {isOpen ? <Icon name="arrow-up" /> : <Icon name="arrow-down" />}
      </StyledAccordionTrigger>
    </h3>
  );
});

export default AccordionTrigger;
